import React from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderGuest from "../../components/layout/HeaderGuest";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";


import TopImageHeader from "../../components/seller-registration/TopImageHeader";
import Breadcrumb from "../../components/seller-registration/Breadcrumb";
import Progress from "../../components/seller-registration/Progress";
import DocumentVerificationForm from "../../components/seller-registration/DocumentVerificationForm";


const SellerRegistration = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

    <HeaderGuest />
      
    <TopImageHeader />

    <Breadcrumb title={"Document Verification"} />

    <Progress progressStatus={"onethird"} />

    <DocumentVerificationForm />


      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default SellerRegistration;